import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChatTypeEnum } from '@src/api-messenger';

import { ChatModel } from '../types';
import { WebSocketService } from '../../services';

import { LastChatMessageType } from './types';

@Component({
  selector: 'app-chats-list-item',
  templateUrl: './chats-list-item.component.html',
  styleUrls: ['./chats-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ChatsListItemComponent implements OnChanges {
  private readonly wss = inject(WebSocketService);
  private readonly translateService = inject(TranslateService);

  @Input() item!: ChatModel;

  lastChatMessage?: LastChatMessageType;

  get senderName() {
    if (
      this.item.chatType === ChatTypeEnum.Chanel ||
      this.item.chatType === ChatTypeEnum.PublicChat ||
      this.item.chatType === ChatTypeEnum.Chat
    ) {
      if (this.isSelf) {
        return this.translateService.instant('common.labels.you');
      }

      return this.item.lastChatMessage?.senderUserName;
    }

    return;
  }

  get isSelf() {
    return this.wss.authUserId === this.item.lastChatMessage?.senderUserId;
  }

  get unreadCount(): string {
    return String(this.item.unreadMessageCount || '');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.item) {
      this.setLastMessage(this.item);
    }
  }

  private setLastMessage(item: ChatModel) {
    // TODO: переписать логику на типы MessageContentTypeEnum
    const mainType = item.lastChatMessage?.contentType?.split('/')[0];
    const messageText = item.lastChatMessage?.messageText;

    switch (mainType) {
      case 'image':
        this.lastChatMessage = {
          icon: 'image',
          text: messageText || this.translateService.instant('common.labels.photo'),
        };
        break;

      case 'video':
        this.lastChatMessage = {
          icon: 'video',
          text: messageText || this.translateService.instant('common.labels.video'),
        };
        break;

      case 'application':
      case 'file':
        this.lastChatMessage = {
          icon: 'file',
          text: messageText || this.translateService.instant('common.labels.file'),
        };
        break;

      default:
        this.lastChatMessage = { text: messageText };
        break;
    }
  }
}
